export const ORDER_STATUS = {
  STATUS_0: {
    desc: '未支付',
    value: '0'
  },
  STATUS_1: {
    desc: '已支付',
    value: '1'
  },
  STATUS_2: {
    desc: '已完成',
    value: '2'
  },
  STATUS_3: {
    desc: '已取消',
    value: '3'
  }
}